import { render, staticRenderFns } from "./accaduto.vue?vue&type=template&id=678cd8a7"
import script from "./accaduto.vue?vue&type=script&lang=js"
export * from "./accaduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678cd8a7')) {
      api.createRecord('678cd8a7', component.options)
    } else {
      api.reload('678cd8a7', component.options)
    }
    module.hot.accept("./accaduto.vue?vue&type=template&id=678cd8a7", function () {
      api.rerender('678cd8a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/accaduto.vue"
export default component.exports